var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrimboxGmail = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1709,
    height: 900,
    viewBox: "0 0 1709 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1259 900C1507.53 900 1709 698.528 1709 450C1709 201.472 1507.53 0 1259 0C1010.47 0 809 201.472 809 450C809 698.528 1010.47 900 1259 900Z",
    fill: "#B1CBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1424.03 264.56L1260.75 389L1093.73 264.56V264.594L1093.93 264.762V439.011L1258.86 566.142L1424.03 443.921V264.56Z",
    fill: "#EA4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1466.91 234.291L1424.03 264.56V443.921L1558.97 342.755V281.813C1558.97 281.813 1542.59 194.773 1466.91 234.291Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1424.03 443.922V676.557H1527.45C1527.45 676.557 1556.88 673.597 1559 640.839V342.755L1424.03 443.922Z",
    fill: "#34A853"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1093.93 676.758V439.01L1093.73 438.842L1093.93 676.758Z",
    fill: "#C5221F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1093.73 264.593L1051.09 234.492C975.413 194.974 959 281.981 959 281.981V342.923L1093.73 438.843V264.593Z",
    fill: "#C5221F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1093.73 264.594V438.843L1093.93 439.011V264.762L1093.73 264.594Z",
    fill: "#C5221F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M959 342.957V641.04C961.085 673.832 990.547 676.758 990.547 676.758H1093.97L1093.73 438.842L959 342.957Z",
    fill: "#4285F4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M450 900C698.528 900 900 698.528 900 450C900 201.472 698.528 0 450 0C201.472 0 0 201.472 0 450C0 698.528 201.472 900 450 900Z",
    fill: "#43FFDD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M477.653 544.974L553.522 150.737L553.234 150.682C515.675 143.453 479.368 168.042 472.141 205.6L409.359 531.832L398.502 588.296L465.941 597.133L477.653 544.974Z",
    fill: "#E5E1E5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M414.158 506.899L487.704 492.745L513.566 358.364L440.019 372.517L414.158 506.899Z",
    fill: "#D7D0D6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M745.956 344.04L745.75 342.964L351.512 418.833L315.143 429.168L325.129 490.277L364.656 487.127L691.673 424.194C728.797 417.049 753.101 381.164 745.956 344.04Z",
    fill: "#EFEDEF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M492.565 596.34C527.702 637.969 525.66 700.278 486.439 739.5C445.053 780.885 377.968 780.885 336.591 739.508C295.206 698.123 295.206 631.038 336.591 589.652C348.738 577.506 363.105 568.931 378.375 563.912L382.215 543.98C383.997 534.73 392.938 528.669 402.188 530.451L484.82 546.355C494.07 548.137 500.122 557.07 498.349 566.328L492.565 596.34ZM453.897 706.958C477.302 683.552 477.302 645.608 453.897 622.202C430.483 598.789 392.539 598.789 369.133 622.194C345.719 645.608 345.719 683.552 369.133 706.966C392.539 730.372 430.483 730.372 453.897 706.958Z",
    fill: "#4059FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M189.529 442.59C166.115 466.004 166.115 503.948 189.521 527.353C212.935 550.767 250.879 550.767 274.292 527.353C297.698 503.948 297.698 466.004 274.284 442.59C250.879 419.184 212.935 419.184 189.529 442.59ZM366.036 494.299C367.818 503.549 361.757 512.49 352.507 514.271L332.575 518.111C327.555 533.382 318.98 547.749 306.834 559.895C265.449 601.28 198.364 601.28 156.979 559.895C115.602 518.518 115.602 451.433 156.987 410.048C196.208 370.827 258.518 368.785 300.147 403.922L330.159 398.138C339.417 396.364 348.35 402.417 350.131 411.667L366.036 494.299Z",
    fill: "#4059FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M454.457 441.214C451.086 437.844 451.087 432.381 454.457 429.011L458.317 425.151C461.687 421.781 467.15 421.78 470.52 425.151C473.891 428.521 473.89 433.984 470.52 437.354L466.66 441.214C463.29 444.584 457.827 444.585 454.457 441.214Z",
    fill: "#E5E1E5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrimboxGmail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/trimbox-gmail.458969cc7311d84f9371539df68d6316.svg";